import { Analytics } from 'aws-amplify'
import { User } from '../../contexts/AuthContext/type'
import { TagTypes } from '../../generated/api'
import { Attribute, type EndpointUpdate } from './types'
import { calculateAge, stringBool } from './utils'

export async function updateAnalyticsEndpoint(
  user: User,
  { hasFamily, isFamilyManager }: { hasFamily: boolean; isFamilyManager: boolean },
) {
  const { id, tags, team, info, profile } = user
  const update: EndpointUpdate = {
    optOut: 'NONE',
    address: `MC#${id}`,
    channelType: 'CUSTOM',
    userAttributes: {
      [Attribute.HasFamilyGroup]: [stringBool(hasFamily)],
      [Attribute.IsFamilyManager]: [stringBool(isFamilyManager)],
    },
  }

  if (profile) {
    if (profile.birthDate) update.userAttributes![Attribute.Age] = [calculateAge(profile.birthDate)]
    if (profile.gender) update.userAttributes![Attribute.Gender] = [profile.gender]
    if (profile.lsoaCode) update.userAttributes![Attribute.LSOA] = [profile.lsoaCode]
  }

  if (team) {
    update.userAttributes![Attribute.HasTeam] = ['true']
    if (team.name) update.userAttributes![Attribute.TeamName] = [team.name]
    if (team.type) update.userAttributes![Attribute.TeamType] = [team.type]
    if (team.details.leaders || team.details.leadersEmails) {
      const isRegisteredLeader = team.details.leaders?.includes(user.id) ?? false
      const isUnregisteredLeader = team.details.leadersEmails?.includes(user.profile.email) ?? false
      const isLeader = isRegisteredLeader || isUnregisteredLeader
      update.userAttributes![Attribute.IsTeamLeader] = [stringBool(isLeader)]
    }
  }

  if (tags) {
    const hasCard = tags.filter((t) => [TagTypes.Card, TagTypes.Fob].includes(t.tagType)).length > 0
    update.userAttributes![Attribute.HasCard] = [stringBool(hasCard)]
    const hasApp = tags.filter((t) => t.tagType === TagTypes.App).length > 0
    update.userAttributes![Attribute.HasApp] = [stringBool(hasApp)]
  }

  if (info && info.gameId) update.userAttributes![Attribute.GameId] = [info.gameId]

  try {
    await Analytics.updateEndpoint(update)
  } catch (error) {
    console.error(error)
  }
}
